/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function libraryDiscountStart(outletIds: string[]) {
  pushClevertapEvent('Library Discount Start', {
    'Current Selected Outlet': outletIds.join(','),
  });
}

export function libraryDiscountChangeOutlet({ prevOutlet, currOutlet }) {
  pushClevertapEvent('Library Discount Change Outlet', {
    'Previous Selected Outlet': prevOutlet,
    'Current Selected Outlet': currOutlet,
  });
}

export function libraryDiscountCreate({ discount, allOutlet }) {
  const eventName = allOutlet
    ? 'Library Discount Create All Outlet'
    : 'Library Discount Create One Outlet';
  pushClevertapEvent(eventName, {
    Name: discount.name,
    Value: discount.amount,
    Type: discount.type,
  });
}

export function libraryDiscountUpdate({ oldDiscount, newDiscount }) {
  pushClevertapEvent('Library Discount Update One Outlet', {
    'Old Name': oldDiscount.name,
    'Old Type': oldDiscount.type ? 'percentage' : 'rupiah',
    'New Name': newDiscount.name,
    'New Type': newDiscount.type,
    Value: newDiscount.amount,
  });
}

export function libraryDiscountDelete({ discount }) {
  pushClevertapEvent('Library Discount Delete', {
    Name: discount.name,
    Type: discount.type,
    Value: discount.amount,
  });
}

export function backofficeDiscountVisit() {
  pushClevertapEvent('BO Discount Visit');
}

export function backofficeManageDiscountCreate({ discount }) {
  pushClevertapEvent('BO Discount Create', {
    Name: discount.name,
    Value: discount.amount,
    Type: discount.type,
    'Business ID': discount.business_id,
    'Outlet Assign': discount.outlet_ids.length,
  });
}

export function backofficeManageDiscountUpdate({ discount, oldDiscount }) {
  const outletCreated = discount.updated_outlet_ids.filter(
    (outlet_id) => !oldDiscount.outlet_ids.includes(outlet_id)
  );
  pushClevertapEvent('BO Discount Update', {
    'Old Name': oldDiscount.name,
    'Old Value': oldDiscount.amount,
    'Old Type': oldDiscount.type,
    'Old Outlet Assign': oldDiscount.outlet_ids.length,
    'New Name': discount.name,
    'New Value': discount.amount,
    'New Type': discount.type,
    'Business ID': oldDiscount.business_id,
    'New Outlet Assign': discount.updated_outlet_ids.length,
    'Outlet Changed': outletCreated.length + discount.deleted_outlet_ids.length,
  });
}

export function backofficeManageDiscountDelete({ discount }) {
  pushClevertapEvent('BO Discount Delete', {
    Name: discount.name,
    Value: discount.amount,
    Type: discount.type,
    'Business ID': discount.business_id,
    'Old Outlet Assign': discount.outlet_ids.length,
    'New Outlet Assign': 0,
    'Outlet Changed': discount.outlet_ids.length,
  });
}

export function backofficeManageDiscountNameError(
  name,
  businessId,
  action,
  email,
  phone
) {
  pushClevertapEvent('BO Discount Name Error Uniqueness', {
    Name: name,
    'Business ID': businessId,
    Action: action,
    'User Email': email,
    'User Phone Number': phone,
  });
}
